import { shortBaseUrl } from '@/config.js';
import { getStorage, setStorage } from '@/utils/storage.js';

export async function getAuthToken() {
  const { token, user_id } = await getStorage(['token', 'user_id']);
  if (token && user_id) {
    return;
  }

  const deviceType = window.location.hostname;
  const res = await fetch(shortBaseUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ path: '/api/login', auth_type: 'chrome', deviceType: deviceType })
  });

  const data = await res.json();

  if (data.result === 'ok') {
    await setStorage({ token: data.token, user_id: data.user_id });
 //   console.log('New token and user_id saved');
  } else {
   // console.error('Failed to get token:', data);
  }
}

export async function getUserInfo() {
    try {
        const { token } = await getStorage(['token']);
        if (!token) {
            await getAuthToken();
            return { success: false, error: 'Токен не найден' };
        }
        const browserLang = navigator.language.split('-')[0];
        const locale = ['ru', 'en'].includes(browserLang) ? browserLang : defaultLocale;

        const res = await fetch(shortBaseUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                path: '/api/balance/getAndroid',
                deviceType: window.location.hostname,
                token,
                locale
            })
        });

        const data = await res.json();
                console.log(data)

        if (data) {
            return { success: true, userInfo: data };
        } else {
            return { success: false, error: 'Некорректный ответ сервера' };
        }
    } catch (e) {
        return { success: false, error: e.message };
    }
}